import LabelInput from 'components/Base/LabelInput';
import LabelTextArea from 'components/Base/LabelTextArea';
import useStyles from './styles';

const Step1 = (props: any) => {
  const classes = useStyles();
  const { name, description, onChange, errorName } = props;

  const onChangeNameExercise = (e: any) => {
    onChange(e?.target?.value, 'name');
  };

  const onChangeDesExercise = (event: any) => {
    onChange(event?.target?.value, 'description');
  };


  return (
    <div className={classes.container}>
      <div className={classes.boxForm}>
        <div className={classes.leftForm}>
          <LabelInput
            label='Name'
            value={name}
            onChange={onChangeNameExercise}
            errors={errorName}
            maxLength={50}
          />
          <LabelTextArea
            label='Description'
            optional={true}
            value={description}
            onChange={onChangeDesExercise}
            maxLength={255}
          />
        </div>
      </div>
    </div>
  );
};

export default Step1;
